import { ILstParcelasParaPositivacaoBody } from "../../../Interfaces/Cobranca/Serasa/Positivar";
import {
    ExecutarPositivacaoSerasaService,
    ListarClientesParcelasPositivarSerasaExportarExcelService,
    ListarClientesParcelasPositivarSerasaService,
    ListarParcelasParaPositivacaoExportarExcelService,
    ListarParcelasParaPositivacaoService,
} from "../../../Services/Cobranca/Serasa/Positivar";
import { Controller } from "../../Controller";

export async function ListarClientesParcelasPositivarSerasaController(requestBody: {
    DS_CLIENTE: string;
    ID_EMPREENDIMENTO: string | number[];
    NR_CPF_CNPJ: string;
    DS_TIPO_CLIENTE: string;
    NR_VENDA: string;
    QUANTIDADE: number;
    PAGINA: number;
    DS_STATUS_PARCELA: string;
}) {
    return Controller(
        ListarClientesParcelasPositivarSerasaService(requestBody)
    );
}

export async function ListarClientesParcelasPositivarSerasaExportarExcelController(
    requestBody: {
        DS_CLIENTE: string;
        ID_EMPREENDIMENTO: string | number[];
        NR_CPF_CNPJ: string;
        DS_TIPO_CLIENTE: string;
        NR_VENDA: string;
        QUANTIDADE: number;
        PAGINA: number;
    },
    flExcel?: boolean
) {
    return Controller(
        ListarClientesParcelasPositivarSerasaExportarExcelService(
            requestBody,
            flExcel
        )
    );
}

export async function ListarParcelasParaPositivacaoController(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: ILstParcelasParaPositivacaoBody
) {
    return Controller(
        ListarParcelasParaPositivacaoService(PAGINA, QUANTIDADE, requestBody)
    );
}

export async function ListarParcelasParaPositivacaoExportarExcelController(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: ILstParcelasParaPositivacaoBody,
    flExcel?: boolean
) {
    return Controller(
        ListarParcelasParaPositivacaoExportarExcelService(
            PAGINA,
            QUANTIDADE,
            requestBody,
            flExcel
        )
    );
}

export async function ExecutarPositivacaoSerasaController(
    dsMotivoPositivacao: string,
    requestBody: Array<number>
) {
    return Controller(
        ExecutarPositivacaoSerasaService(dsMotivoPositivacao, requestBody)
    );
}
